import { render, staticRenderFns } from "./DCIInputFormReslut.vue?vue&type=template&id=15b6585d&scoped=true"
import script from "./DCIInputFormReslut.vue?vue&type=script&lang=js"
export * from "./DCIInputFormReslut.vue?vue&type=script&lang=js"
import style0 from "./DCIInputFormReslut.vue?vue&type=style&index=0&id=15b6585d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b6585d",
  null
  
)

export default component.exports